import { BROWSER } from 'esm-env';
import { ofetch } from 'ofetch';
import { log } from '@shared/log.browser.ts';
import type { VariationLoader } from '@tilelist/application/ports/VariationLoader.ts';
import { CrocotileClient } from '@tilelist/clients/CrocotileClient';
import { TrackingService } from '@tilelist/services/TrackingService.browser';
import { VariationLoadingService } from '@tilelist/services/VariationLoadingService';

let CROCOTILE_INSTANCE: CrocotileClient | null = null;
let VARIATION_LOADING_SERVICE: VariationLoader | null = null;
let TRACKING_SERVICE: TrackingService | null = null;

/**
 *
 */
export function getCrocotileClient(): CrocotileClient {
    if (!BROWSER) throw new Error('This can only be used in the browser environment');
    if (CROCOTILE_INSTANCE) return CROCOTILE_INSTANCE;

    CROCOTILE_INSTANCE = new CrocotileClient({
        fetchClient: ofetch,
        logger: log,
        timeout: 2000,
    });

    return CROCOTILE_INSTANCE;
}

/**
 *
 */
export function getVariationLoadingService(): VariationLoader {
    if (!BROWSER) throw new Error('This can only be used in the browser environment');
    if (VARIATION_LOADING_SERVICE) return VARIATION_LOADING_SERVICE;

    VARIATION_LOADING_SERVICE = new VariationLoadingService(getCrocotileClient());
    return VARIATION_LOADING_SERVICE;
}

/**
 *
 *
 */
export function getTrackingService(): TrackingService {
    if (!BROWSER) throw new Error('This can only be used in the browser environment');
    if (TRACKING_SERVICE) return TRACKING_SERVICE;

    TRACKING_SERVICE = new TrackingService();
    return TRACKING_SERVICE;
}
